import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const DocumentIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width="60"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 43.07 47"
      {...props}>
      <g>
        <path d="M42.6,16.11V16h-.11L28,1.14V1h-.13l-1-1H6V22H4.29A4.3,4.3,0,0,0,0,26.29v8.47a4.3,4.3,0,0,0,4.29,4.29H6v8H43.07V16.59ZM39.7,16H30.86A3.37,3.37,0,0,1,28,12.87V4ZM2,34.76V26.29A2.3,2.3,0,0,1,4.29,24H27.71A2.3,2.3,0,0,1,30,26.29v8.47a2.3,2.3,0,0,1-2.29,2.29H4.29A2.3,2.3,0,0,1,2,34.76ZM8,45v-6H27.71A4.3,4.3,0,0,0,32,34.76V26.29A4.3,4.3,0,0,0,27.71,22H8V2H26V12.87A5.34,5.34,0,0,0,30.6,18H41.07V45Z" />
      </g>
    </StyledSVGIcon>
  );
};